import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';

interface LegalPageProps {
  title: string;
  updated: string;
  children: ReactNode;
  onBackHome: () => void;
}

export function LegalPage({ title, updated, children, onBackHome }: LegalPageProps) {
  return (
    <main className="relative z-10 min-h-screen bg-black pt-24">
      <section className="py-14 sm:py-18">
        <div className="container mx-auto px-5">
          <div className="max-w-3xl">
            <button
              onClick={onBackHome}
              className="inline-flex items-center gap-2 text-sm font-medium text-white/70 hover:text-white transition-colors duration-200 mb-6"
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </button>

            <div className="flex items-start justify-between gap-4">
              <div>
                <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white">
                  {title}
                </h1>
                <div className="mt-2 text-sm text-white/40">Last updated: {updated}</div>
              </div>
            </div>

            <div className="mt-10 space-y-8 text-sm sm:text-base leading-relaxed text-white/60">
              {children}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
